export const en = {
    cancel: 'Cancel',
    'check-all': 'Select all ({total})',
    copy: 'Copy',
    crop: 'Crop again',
    'filtered-items': 'Filtered: {filteredOut}',
    'item-id': 'ID: {id}',
    'item-size': '{width}x{height}',
    submit: 'Select sizes',
    title: 'Sizes of the "{creativeName}" ad group'
};
